import React, {Component} from 'react';
import loading from "asset/img/text-animation-1s-262x71px.svg"
export default class Loader extends Component {
    render() {
        if(this.props.loading===true){
            return (
                <div className="background-loader">
                    {/* <div
                        className="lds-css ng-scope"
                      >
                        <div className="lds-double-ring">
                            <div></div>
                            <div></div>
                        </div>
                    </div> */}
                    <img src={loading} className="loader-img" alt="Loading"/>
                </div>
            )
        }
        else{
            return(
                <div></div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Loader.jsx